import { OrDivider } from 'components/atoms';
import Image from 'next/image';
import { signIn } from 'next-auth/react';
import React from 'react';
import { useTranslation } from 'utils/hooks';

import css from './SignInWithGoogle.module.scss';

const SignInWithGoogle: React.FC = () =>
{
  const { t } = useTranslation('common');

  return (
    <div className={css.container}>
      <button
        className={css.googleLoginButton}
        onClick={() => signIn('google', { callbackUrl: '/user/register/onboarding' })}
      >
        <Image
          src="/static/images/google.svg"
          alt="Google Logo"
          width={18}
          height={18}
        />
        <div>
          <span>{t('common:user.registerWithGoogle')}</span>
        </div>
      </button>
      <OrDivider variant={'secondary'}/>
    </div>
  );
};

export default SignInWithGoogle;
